module.exports = __webpack_public_path__ + "static/media/logoPP_230x99.a66522bf.png";